import isNil from "lodash/isNil";

import { DataEntryView } from "../../ui/systems/dataEntry/DataEntryViewToggle";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type DataEntryViewState = {
  dataEntryViews: Record<number, DataEntryView>;
};

type DataEntryViewActions = {
  getDataEntryViewBySiteId: (siteId: number, isFlexSite: boolean) => DataEntryView;
  updateDataEntryViewBySiteId: (siteId: number, view: DataEntryView) => void;
  resetDataEntryViewStore: () => void;
};

const initialState: DataEntryViewState = {
  dataEntryViews: {},
};

export const createDataEntryViewSlice: WaterlyAppStateCreator<DataEntryViewActions, DataEntryViewState> = (
  set,
  get,
) => ({
  ...initialState,
  getDataEntryViewBySiteId: (siteId, isFlexSite) => {
    const { dataEntryViews } = get();
    const savedView = dataEntryViews?.[siteId];
    if (!isNil(savedView)) {
      return savedView;
    }
    return isFlexSite ? DataEntryView.FOLDER : DataEntryView.PROCESS;
  },
  updateDataEntryViewBySiteId: (siteId: number, view) => {
    const { dataEntryViews } = get();
    set(
      {
        dataEntryViews: {
          ...dataEntryViews,
          [siteId]: view,
        },
      },
      undefined,
      "dataEntryView:updateDataEntryViewBySiteId",
    );
  },
  resetDataEntryViewStore: () => {
    set(initialState, undefined, "dataEntryView:resetDataEntryViewStore");
  },
});
